module.exports = __webpack_public_path__ + "static/media/dark-motion-orbital-transfer.0764a9c.mp4";